<template>
  <div
		class="ctn-input ctn-label"
		v-inputUI
		:class="{ error: error || errors.has(name) }">
		<label
			v-if="!notLabel"
			:for="name"
			@click="$refs.input.focus()">
			<span>{{ label || name }}</span>
			<span class="label-required" v-if="rules.includes('required')"> *</span>
		</label>
		<input
			class="input"
			:id="name"
			:type="type"
			:placeholder="placeholder"
			ref="input"
			v-model="innerValue"
			:class="{'has-value': hasValue, 'is-danger':  error || errors.first(name)}"
			:v-validate="rules"
		>
		<p
			class="error-message"
			v-if="error || errors.has(name)">{{ error || errors.first(name) }}</p>
  </div>
</template>

<script>
export default {
	name: 'TextInput',
	props: {
		name: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		rules: {
			type: [Object, String],
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		error: {
			type: String,
			default: ''
		},
		notLabel: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'text',
			validator (value) {
				return [
					'url',
					'text',
					'password',
					'tel',
					'search',
					'number',
					'email',
					'date'
				].includes(value)
			}
		},
		value: {
			type: null,
			default: ''
		}
	},
	data: () => ({
		innerValue: '',
		hasFocus: false
	}),
	computed: {
		hasValue () {
			return !!this.innerValue
		}
	},
	watch: {
		innerValue (value) {
			if (value && !this.hasFocus) {
				this.$refs.input.focus()
				this.hasFocus = true
			}

			this.$emit('input', value)
		},
		value (val) {
			if (val !== this.innerValue) {
				this.innerValue = val
			}
		}
	},
	created () {
		if (this.value) {
			this.innerValue = this.value
		}
	}
}
</script>



// WEBPACK FOOTER //
// TextInput.vue?6cb416e0